/* eslint-disable no-restricted-syntax -- this line was auto generated, hence fix the issue timely */
import React, { useRef } from "react";
import { useViewport } from "@bookingcom/bui-react";
import { DESKTOP_SIDEBAR_WIDTH_SMALLER } from "../../../../constants";
import useSideBarSticky from "./useSideBarSticky";
import Frame, { PaddingDirection } from "../../Frame";
import { trackWithDefaultStage } from "@flights/et-universal";
import { useSelector } from "react-redux";
import { getFlight } from "../../../../store/flightDetails/selectors";
import useFlightsWebDdotCheckoutImprovedHeading from "../../../../utils/experiments/funnel/flights_web_ddot_checkout_improved_heading";
import useRouteName from "../../../../hooks/useRouteName";

type Props = {
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
  fixScrollPadding?: boolean;
  isResponsiveFixes?: boolean;
  isSkeleton?: boolean;
} & PaddingDirection;

const Sidebar = (props: Props) => {
  const { children, p, pt, pr, pb, pl, className, fixScrollPadding, isSkeleton } = props;

  // flights_web_ddot_sticky_price_breakdown -- start
  // ================================================
  const divRef = useRef<HTMLDivElement>(null);
  const { isSmall, isLarge } = useViewport();
  const isResponsiveFixes = !isLarge && !!trackWithDefaultStage("flights_web_cat_responsive_fixes_www", 1);
  const isResponsiveFixesSm = isSmall && !!trackWithDefaultStage("flights_web_cat_responsive_fixes_www", 1);

  useSideBarSticky({ wrapper: divRef?.current, fixScrollPadding });
  // ================================================
  // flights_web_ddot_sticky_price_breakdown -- end

  const routName = useRouteName(); // flights_web_ddot_checkout_improved_heading
  const flight = useSelector(getFlight); // flights_web_ddot_checkout_improved_heading
  const { isVariant: isVariantHeading } = useFlightsWebDdotCheckoutImprovedHeading(); // flights_web_ddot_checkout_improved_heading
  const topOffset = // flights_web_ddot_checkout_improved_heading
    routName !== "checkout-start" &&
    routName.startsWith("checkout") &&
    isVariantHeading &&
    ((isSkeleton && !!flight) || !isSkeleton)
      ? routName === "checkout-ticket-type"
        ? -142
        : -94
      : undefined;
  return (
    <Frame
      className={className}
      direction="column"
      p={p}
      pt={pt}
      pr={pr}
      pb={pb}
      pl={pl}
      attributes={{
        style: {
          ...props.style,
          flexShrink: 0,
          width: isResponsiveFixesSm || isResponsiveFixes ? "100%" : DESKTOP_SIDEBAR_WIDTH_SMALLER,
          marginTop: topOffset
        }
      }}
    >
      <div ref={divRef}>{children}</div>
    </Frame>
  );
};

export default Sidebar;
